export default [
    [256, 171],
    [266, 177],
    [326, 217],
    [352, 235],
    [424, 283],
    [440, 293],
    [450, 300],
    [460, 307],
    [542, 361],
    [570, 380],
    [580, 387],
    [676, 451],
    [700, 467],
    [970, 546],
    [1050, 700],
    [2400, 1600],
];
